function TransactionReportsCtrl(toaster, $scope, $state, $stateParams, $rootScope, TransactionReportsService, UserService) {
  'ngInject';

  const vm = this;
  const orgId = $stateParams.orgId;

  vm.runs = [];
  vm.mapping = {};
  vm.accounts = [];
  vm.loading = true;
  vm.uploading = false;
  vm.fetchingRequested = false;
  vm.selectedFile = null;
  vm.marketplace = 'amazon.com';
  vm.accountingProvider = null;
  vm.providerDetection = null;
  vm.fetchMonth = moment().subtract(1, 'month').format('YYYY-MM');
  vm.accountsLoading = false;
  vm.accountsError = null;

  vm.marketplaces = [
    { value: 'amazon.com', label: 'Amazon US' },
    { value: 'amazon.ca', label: 'Amazon CA' },
    { value: 'amazon.com.mx', label: 'Amazon MX' }
  ];

  vm.accountingProviders = [
    { value: 'xero', label: 'Xero' },
    { value: 'qbo', label: 'QuickBooks' }
  ];

  function hasConnection(connection) {
    if (!connection) return false;
    if (Array.isArray(connection)) return connection.length > 0;
    if (typeof connection === 'object') return Object.keys(connection).length > 0;
    return true;
  }

  function providerFromOrganization(org) {
    if (!org) return null;

    var hasXero = hasConnection(org.api_v1_xero_connection);
    var hasQbo = hasConnection(org.api_v1_qbo_connection);

    if (hasXero && !hasQbo) return 'xero';
    if (hasQbo && !hasXero) return 'qbo';

    // If both are connected, keep Xero as the safer/default legacy path unless
    // the organization is explicitly a QBO company. This avoids silently sending
    // long-running Xero clients to QBO just because QBO support exists.
    if (hasXero && hasQbo) {
      return org.organisation_type === 'qbo_company' ? 'qbo' : 'xero';
    }

    return null;
  }

  function setAccountingProvider(provider, source) {
    vm.accountingProvider = provider || 'xero';
    vm.providerDetection = source || (provider ? 'detected' : 'fallback');
    vm.loadAccounts();
  }

  vm.detectAccountingProvider = function () {
    var currentOrg = $rootScope.currentOrgObj;
    var detectedProvider = providerFromOrganization(currentOrg);

    if (detectedProvider) {
      setAccountingProvider(detectedProvider, 'detected');
      return;
    }

    UserService.organizations(orgId, function(response) {
      var data = response && response.data;
      var org = null;

      if (data && data.default_organization) {
        org = data.default_organization;
      } else if (data && data.organizations) {
        var match = data.organizations.find(function(item) {
          return item.organization && item.organization.id == orgId;
        });
        org = match && match.organization;
      }

      setAccountingProvider(providerFromOrganization(org), providerFromOrganization(org) ? 'detected' : 'fallback');
    });
  };

  function uploadErrorMessage(response) {
    var errorMsg = 'Failed to upload file';
    var responseData = response && response.data;

    if (responseData) {
      if (responseData.error) {
        return responseData.error;
      } else if (typeof responseData === 'string') {
        return responseData;
      }
    }

    var rawResponse = response && (response.response || (response.xhr && response.xhr.responseText));
    if (rawResponse) {
      try {
        var parsedResponse = typeof rawResponse === 'string' ? JSON.parse(rawResponse) : rawResponse;
        if (parsedResponse && parsedResponse.error) {
          return parsedResponse.error;
        }
      } catch (e) {
        if (typeof rawResponse === 'string') {
          return rawResponse;
        }
      }
    }

    return errorMsg;
  }

  // Load runs
  vm.load = function () {
    vm.loading = true;
    TransactionReportsService.getRuns(orgId, { marketplace: vm.marketplace }).then(function (response) {
      vm.runs = response.data.runs || [];
      vm.loading = false;
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to load transaction reports');
      vm.loading = false;
    });
  };

  // Load mapping/settings
  vm.loadMapping = function () {
    TransactionReportsService.getMapping(orgId, vm.marketplace).then(function (response) {
      vm.mapping = response.data.settings || {};
    });
  };

  // Load accounting accounts
  vm.loadAccounts = function () {
    if (!vm.accountingProvider) return;

    vm.accountsLoading = true;
    vm.accountsError = null;
    TransactionReportsService.getAccounts(orgId, vm.accountingProvider).then(function (response) {
      vm.accounts = response.data.accounts || [];
      vm.accountsLoading = false;
    }).catch(function(error) {
      console.error('Failed to load accounting accounts:', error);
      vm.accountsLoading = false;
      vm.accountsError = 'Failed to load ' + vm.providerLabel() + ' accounts. Is ' + vm.providerLabel() + ' connected?';
    });
  };

  // File selected
  vm.onFileSelect = function (files) {
    if (files && files.length > 0) {
      vm.selectedFile = files[0];
    }
  };

  // Upload file
  vm.upload = function () {
    if (!vm.selectedFile) {
      toaster.pop('warning', 'No File', 'Please select a file to upload');
      return;
    }

    vm.uploading = true;
    TransactionReportsService.upload(orgId, vm.selectedFile, vm.marketplace, function(response) {
      vm.uploading = false;
      if (response.status === 200) {
        toaster.pop('success', 'Uploaded', response.data.message || 'Transaction report uploaded and parsed successfully');
        vm.selectedFile = null;
        vm.load();
      } else {
        toaster.pop('error', 'Upload Failed', uploadErrorMessage(response));
      }
    });
  };

  // Fetch already-requested Seller Central Transaction Report
  vm.fetchRequested = function () {
    if (!vm.fetchMonth) {
      toaster.pop('warning', 'No Month', 'Please select a month to fetch');
      return;
    }

    vm.fetchingRequested = true;
    TransactionReportsService.fetchRequested(orgId, vm.marketplace, vm.fetchMonth + '-01').then(function (response) {
      vm.fetchingRequested = false;
      toaster.pop('success', 'Fetched', response.data.message || 'Requested Transaction Report fetched and parsed successfully');

      if (response.data && response.data.run) {
        var returnedRun = response.data.run;
        var replaced = false;

        vm.runs = (vm.runs || []).map(function (run) {
          if (run.id === returnedRun.id) {
            replaced = true;
            return returnedRun;
          }
          return run;
        });

        if (!replaced) {
          vm.runs.unshift(returnedRun);
        }
      }

      vm.load();
    }).catch(function (error) {
      vm.fetchingRequested = false;
      var msg = error.data && error.data.error ? error.data.error : 'Failed to fetch requested Transaction Report';
      toaster.pop('error', 'Fetch Failed', msg);
    });
  };

  // Save mapping
  vm.saveMapping = function () {
    vm.mapping.marketplace = vm.marketplace;
    
    // Validate required accounts
    var required = [
      { field: 'product_sales_account', label: 'Product Sales' },
      { field: 'refunds_account', label: 'Refunds' },
      { field: 'selling_fees_account', label: 'Selling Fees' },
      { field: 'fba_fees_account', label: 'FBA Fees' },
      { field: 'clearing_account', label: 'Clearing Account' }
    ];
    var missing = required.filter(function(r) {
      return !vm.mapping[r.field];
    });
    
    if (missing.length > 0) {
      var missingLabels = missing.map(function(m) { return m.label; }).join(', ');
      toaster.pop('warning', 'Incomplete Mapping', 'Required accounts missing: ' + missingLabels + '. Status will remain "mapping" until these are filled.');
    } else if (!vm.mapping.enabled) {
      // A complete mapping should be immediately postable. The enable checkbox lives
      // inside the collapsed mapping panel, so users were saving complete mappings
      // that still could not post because enabled stayed false.
      vm.mapping.enabled = true;
      toaster.pop('info', 'Posting Enabled', 'Required accounts are mapped, so posting has been enabled for this marketplace.');
    }
    
    TransactionReportsService.saveMapping(orgId, vm.mapping).then(function (response) {
      toaster.pop('success', 'Saved', 'Account mapping saved');
      vm.mapping = response.data.settings || vm.mapping;
      vm.load(); // Refresh runs to update statuses
    }).catch(function (error) {
      var msg = error.data && error.data.error ? error.data.error : 'Failed to save mapping';
      toaster.pop('error', 'Error', msg);
    });
  };

  vm.providerLabel = function () {
    return vm.accountingProvider === 'qbo' ? 'QuickBooks' : 'Xero';
  };

  vm.changeAccountingProvider = function () {
    vm.providerDetection = 'manual';
    vm.loadAccounts();
  };

  // Post to accounting provider
  vm.postRun = function (run) {
    var provider = vm.accountingProvider;
    var label = vm.providerLabel();
    if (!confirm('Post ' + run.period_display + ' to ' + label + '?')) return;

    var request = provider === 'qbo'
      ? TransactionReportsService.postToQbo(orgId, run.id)
      : TransactionReportsService.postToXero(orgId, run.id);

    request.then(function (response) {
      toaster.pop('success', 'Posted', response.data.message || ('Journal entry created in ' + label));
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', error.data?.error || ('Failed to post to ' + label));
    });
  };

  // Delete run
  vm.deleteRun = function (run) {
    if (!confirm('Delete ' + run.period_display + '? This cannot be undone.')) return;

    TransactionReportsService.deleteRun(orgId, run.id).then(function () {
      toaster.pop('success', 'Deleted', 'Report deleted');
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to delete report');
    });
  };

  // Retry run
  vm.retryRun = function (run) {
    TransactionReportsService.retryRun(orgId, run.id, vm.accountingProvider).then(function () {
      toaster.pop('success', 'Refreshed', 'Report status updated');
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to refresh report');
    });
  };

  // Format currency
  vm.formatCurrency = function (amount) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);
  };

  // Status badge class
  vm.statusClass = function (status) {
    switch (status) {
      case 'done': return 'label-success';
      case 'ready': return 'label-primary';
      case 'mapping': return 'label-warning';
      case 'error': return 'label-danger';
      default: return 'label-default';
    }
  };

  // Initialize
  vm.load();
  vm.loadMapping();
  vm.detectAccountingProvider();
}

TransactionReportsCtrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'TransactionReportsService', 'UserService'];

export default {
  name: 'TransactionReportsCtrl',
  fn: TransactionReportsCtrl
};
